/** @jsx jsx */

import { jsx } from '@emotion/react';
import styled from '@emotion/styled';
import { ModuleComponents } from '../../components/ModuleComponents';

import { media } from '../../services/media';

interface GridProps {
    components?: any;
    gap: string;
    gridColumnsMobile: string;
    gridColumnsTablet: string;
    gridColumnsDesktop: string;
}

export const Grid: React.FC<GridProps> = ({ components, ...props }) => {
    return (
        <StyledGrid {...props}>
            <ModuleComponents components={components} />
        </StyledGrid>
    );
};

const StyledGrid = styled.div<GridProps>`
    display: grid;
    max-width: 100%;

    ${(props) => `
        gap: ${props.gap};

        ${media.max('md')} {
            grid-template-columns: ${props.gridColumnsMobile};
        }

        ${media.between('md', 'lg')} {
            grid-template-columns: ${props.gridColumnsTablet};
        }

        ${media.min('lg')} {
            grid-template-columns: ${props.gridColumnsDesktop};
        }
    
    `};
`;

const Item = styled.div`
    text-align: center;
`;

const Image = styled.img`
    display: block;
    width: 100%;
    max-width: 100%;
    margin: 0 0 30px;
`;

const Heading = styled.h3`
    margin: 0 0 30px;

    ${media.max('lg')} {
        font-size: 24px;
    }

    ${media.min('lg')} {
        font-size: 36px;
    }
`;

const Text = styled.div`
    p {
        margin: 0;

        font-weight: 300;
        line-height: 1.4;

        ${media.max('lg')} {
            font-size: 18px;
        }

        ${media.min('lg')} {
            font-size: 20px;
        }
    }
`;
